export const RTL_LANGUAGES = new Set(["ar", "ur", "fa", "he"]);

export const isRTL = (lang) => RTL_LANGUAGES.has(String(lang || "").toLowerCase());

export const dirForLang = (lang) => (isRTL(lang) ? "rtl" : "ltr");

export const rtlAware = (lang, ltrValue, rtlValue) =>
  isRTL(lang) ? rtlValue : ltrValue;

export const directionalArrow = (lang, previousIcon, nextIcon) => ({
  previous: isRTL(lang) ? nextIcon : previousIcon,
  next: isRTL(lang) ? previousIcon : nextIcon,
});
